import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_CONTACT_CHANGE_PASSWORD_WITH_HASH_POST_REQUEST = "API_CONTACT_CHANGE_PASSWORD_WITH_HASH_POST_REQUEST";
export const API_CONTACT_CHANGE_PASSWORD_WITH_HASH_POST_SUCCESS = "API_CONTACT_CHANGE_PASSWORD_WITH_HASH_POST_SUCCESS";
export const API_CONTACT_CHANGE_PASSWORD_WITH_HASH_POST_FAILURE = "API_CONTACT_CHANGE_PASSWORD_WITH_HASH_POST_FAILURE";

export const api_contact_change_password_with_hash_post_request = (options) => {
	return {
		type: API_CONTACT_CHANGE_PASSWORD_WITH_HASH_POST_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_contact_change_password_with_hash_post_success = (data) => {
	return {
		type: API_CONTACT_CHANGE_PASSWORD_WITH_HASH_POST_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_contact_change_password_with_hash_post_failure = (error) => {
	return {
		type: API_CONTACT_CHANGE_PASSWORD_WITH_HASH_POST_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Contact.apiContactChangePasswordWithHash_post
*/
export const apiContactChangePasswordWithHash_post = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_contact_change_password_with_hash_post_request(options));
			const url=getAPIUrl([
				{"url": "/api/contact/change_password_with_hash", "parameters": []},
			], options);
			axios({
				method: "post",
				url: url,
				data: {
					PASSWORD: options.PASSWORD,
					HASH: options.HASH,
				},
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_contact_change_password_with_hash_post_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_contact_change_password_with_hash_post_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
